import {Component} from '@angular/core';
import {Router, NavigationEnd} from "@angular/router";
import {filter} from "rxjs/operators";

@Component({
  selector: 'app-menu-edit',
  templateUrl: './menu-edit.component.html',
  styleUrls: ['./menu-edit.component.scss']
})
export class MenuEditComponent {
  selectedIndex = 0;

  constructor(
    private router: Router
  ) {
    // Sync selected tab with current route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateSelectedIndex();
    });

    // Initialize on load
    this.updateSelectedIndex();
  }

  private updateSelectedIndex(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/promo')) {
      this.selectedIndex = 1;
    } else {
      // Default to modifier-group (including empty path and modifier-group)
      this.selectedIndex = 0;
    }
  }
}
